<script setup>

import {ref} from "vue";

const emits = defineEmits(['handleFolderOpened'])

const props = defineProps({
  folders: {type: Array, required: true},
  showSchedule: {type: Boolean, required: true},
  currentFolder: String,
  openFolder: Function,
  onDrop: Function
})


const openFolders = ref(new Set());

function openFolderAction(folder, $event) {
  if($event.target.classList.contains('folder-open')) {
    toggleFolder(folder.folder_id)
    return;
  }

  if(!folder.isDirectory) {
    toggleFolder(folder.folder_id)
    return;
  }

  if(folder.children && folder.children.length) {
    emits('handleFolderOpened', folder.folder_id)
  }else {
    emits('handleFolderOpened', folder.folder_id)
  }
}

const toggleFolder = (id) => {
  if (openFolders.value.has(id)) {
    openFolders.value.delete(id);
  } else {
    openFolders.value.add(id);
  }
}


</script>

<template>
  <div class="card card-body shadow-sm mb-5">
    <div v-if="folders.length" v-for="folder in folders" :key="folder.folder_id" style="cursor: pointer;">
      <div
          class="d-flex justify-content-between align-items-center p-3 folder"
          :class="currentFolder === folder.folder_id ? 'active_tab' : ''"
          @click="openFolderAction(folder, $event)"
          @dragover.prevent
          @drop="onDrop(folder)"
      >
        <div class="d-flex align-items-center">
          <i class="fa folder-open fa-2x" :class="openFolders.has(folder.folder_id) ? 'fa-caret-down' : 'fa-caret-right'" v-if="folder.children && folder.children.length"></i>
          <span :class="currentFolder === folder.folder_id ? 'text-primary' : 'text-muted'" class="fs-4 ms-3">{{ folder.title }}</span>
        </div>
        <span v-if="folder.isDirectory && folder.count > 0" class="badge p-3" :class="currentFolder === folder.folder_id ? 'badge-primary' : 'badge-light'">{{ folder.count }}</span>
      </div>

      <div v-if="openFolders.has(folder.folder_id)" class="ms-5">
        <div v-for="child in folder.children" :key="child.id" style="cursor: pointer;">
          <div
              class="d-flex justify-content-between align-items-center p-3 folder"
              :class="currentFolder === child.folder_id ? 'active_tab' : ''"
              @click="openFolderAction(child, $event)"
          >
            <div class="d-flex align-items-center">
              <i class="fa folder-open fa-2x" :class="openFolders.has(child.folder_id) ? 'fa-caret-down' : 'fa-caret-right'" v-if="child.children && child.children.length"></i>
              <span :class="currentFolder === child.folder_id ? 'text-primary' : 'text-muted'" class="fs-4 ms-3">{{ child.title }}</span>
            </div>
            <span v-if="child.count > 0" class="badge p-3" :class="currentFolder === child.folder_id ? 'badge-primary' : 'badge-light'">{{ child.count }}</span>
          </div>

          <div v-if="openFolders.has(child.folder_id)" class="ms-5">
            <div v-for="subChild in child.children" :key="subChild.folder_id" style="cursor: pointer;">
              <div
                  class="d-flex justify-content-between align-items-center p-3 folder"
                  :class="currentFolder === subChild.folder_id ? 'active_tab' : ''"
                  @click="openFolderAction(subChild, $event)"
              >
                <div class="d-flex align-items-center">
                  <span :class="currentFolder === subChild.folder_id ? 'text-primary' : 'text-muted'" class="fs-4 ms-3">{{ subChild.title }}</span>
                </div>
                <span v-if="subChild.count > 0" class="badge p-3" :class="currentFolder === subChild.folder_id ? 'badge-primary' : 'badge-light'">{{ subChild.count }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="cursor: pointer;">
      <div
          class="d-flex justify-content-between align-items-center p-3 folder"
          :class="showSchedule ? 'active_tab' : ''"
          @click="openFolderAction('schedule')"
      >
        <div class="d-flex align-items-center">
          <span :class="showSchedule ? 'text-primary' : 'text-muted'" class="fs-4 ms-3">{{ $t('mail.schedule') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.active_tab {
  background-color: var(--bs-light-primary);
  border-radius: 5px;
}

.button {
  position: relative;
  transition: all 0.3s ease-in-out;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.2);
  padding-block: 0.5rem;
  padding-inline: 1.25rem;
  background-color: var(--bs-primary);
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #ffff;
  gap: 10px;
  font-weight: bold;
  border: 3px solid #ffffff4d;
  outline: none;
  overflow: hidden;
  font-size: 15px;
}

.icon {
  width: 24px;
  height: 24px;
  transition: all 0.3s ease-in-out;
}

.button:hover {
  transform: scale(1.05);
  border-color: #fff9;
}

.button:hover .icon {
  transform: translate(4px);
}

.button:hover::before {
  animation: shine 1.5s ease-out infinite;
}

.button::before {
  content: "";
  position: absolute;
  width: 100px;
  height: 100%;
  background-image: linear-gradient(
      120deg,
      rgba(255, 255, 255, 0) 30%,
      rgba(255, 255, 255, 0.8),
      rgba(255, 255, 255, 0) 70%
  );
  top: 0;
  left: -100px;
  opacity: 0.6;
}

@keyframes shine {
  0% {
    left: -100px;
  }

  60% {
    left: 100%;
  }

  to {
    left: 100%;
  }
}

.folder:hover {
  background-color: var(--bs-light-primary) !important;
  border-radius: 5px;
}
</style>